var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 861,
    height: 535,
    viewBox: "0 0 861 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_3849)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 860.475,
    height: 535,
    fill: "#F1CD60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.148 249.877C71.547 213.005 -20.3242 108.211 -20.3242 108.211V535.004H1188.92C1188.92 535.004 1132.32 495.273 1092.04 477.62C1005.1 439.515 928.772 477.62 851.624 441.755C788.333 412.332 680.372 313.242 614.799 289.329C482.033 240.911 371.337 297.644 202.148 249.877Z",
    fill: "#CA5370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.7 180.614C796.164 206.732 861.207 280.961 861.207 280.961L861.207 -21.3505L5.08151 -21.3505C5.08151 -21.3505 45.1576 6.79177 73.6731 19.2964C135.222 46.2869 189.263 19.2964 243.882 44.7007C288.691 65.5421 365.126 135.73 411.551 152.669C505.547 186.965 583.917 146.779 703.7 180.614Z",
    fill: "#A2C166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.741 274.944C223.12 354.519 -44.1377 337.956 -44.1377 337.956L-55.8887 -51.8398L563.977 -41.5821C563.977 -41.5821 555.901 85.16 514.035 150.385C472.725 214.744 429.257 237.034 362.741 274.944Z",
    fill: "#2A406C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.828 418.146C809.127 435.378 921.198 418.146 921.198 418.146H927.55V538.817C927.55 538.817 380.181 772.089 318.823 526.113C302.347 460.062 211.3 392.852 228.638 331.77C279.874 151.262 483.67 137.14 594.461 256.828C647.751 314.398 664.763 398.956 740.828 418.146Z",
    fill: "#4AC1C0",
    stroke: "#4AC1C0",
    strokeWidth: 2.54043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.715 342.539L335.037 364.664",
    stroke: "#232323",
    strokeWidth: 14.5158,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.033 382.551L404.355 404.676",
    stroke: "#232323",
    strokeWidth: 14.5158,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.453 420.328L469.775 442.453",
    stroke: "#232323",
    strokeWidth: 14.5158,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.144 112.233C412.937 109.227 406.278 111.011 403.272 116.218L292.236 308.539C295.7 312.003 298.231 316.343 299.521 321.157C301.453 328.368 300.442 336.052 296.709 342.517C292.976 348.982 286.828 353.7 279.617 355.632C274.803 356.922 269.778 356.9 265.046 355.632L111.782 621.094C108.775 626.301 110.559 632.96 115.767 635.966L173.188 669.118L176.812 662.842L179.092 658.893C181.597 654.553 187.146 653.067 191.485 655.572L248.903 688.722C253.243 691.228 254.729 696.776 252.224 701.116L249.944 705.065L246.32 711.341L303.736 744.49C308.943 747.497 315.601 745.712 318.608 740.505L464.353 488.067L471.871 475.046C468.394 471.578 465.854 467.228 464.561 462.403C462.629 455.191 463.64 447.508 467.373 441.043C471.106 434.578 477.254 429.86 484.465 427.928C489.29 426.635 494.327 426.66 499.069 427.937L610.098 235.629C613.104 230.422 611.32 223.764 606.113 220.757L418.144 112.233ZM272.521 342.686L272.615 342.524C270.135 342.574 267.611 341.969 265.307 340.639L265.295 340.631L265.289 340.641L259.027 337.026L99.2107 613.836C92.196 625.986 96.3588 641.522 108.509 648.537L178.088 688.709L188.749 670.243L237.504 698.391L226.843 716.857L296.478 757.061C308.628 764.076 324.164 759.913 331.179 747.763L476.924 495.325L490.994 470.954L485.132 467.569C484.99 467.494 484.849 467.415 484.708 467.334C482.407 466.006 480.623 464.126 479.427 461.958L479.34 462.109C478.758 461.077 478.303 459.968 477.991 458.804C477.014 455.155 477.526 451.267 479.414 447.995C481.303 444.723 484.415 442.336 488.064 441.358C489.227 441.047 490.415 440.886 491.6 440.874L491.486 441.072C493.955 441.024 496.468 441.625 498.764 442.946L498.768 442.939L505.069 446.577L622.669 242.887C629.684 230.737 625.521 215.201 613.371 208.186L425.402 99.6623C413.252 92.6475 397.716 96.8104 390.701 108.96L273.102 312.648L278.883 315.986C279.05 316.074 279.216 316.166 279.381 316.261C281.686 317.591 283.471 319.475 284.668 321.647L284.761 321.485C285.333 322.508 285.782 323.605 286.09 324.756C287.068 328.405 286.556 332.293 284.668 335.565C282.779 338.836 279.667 341.224 276.018 342.202C274.867 342.51 273.693 342.67 272.521 342.686Z",
    fill: "#232323"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 861,
    width: 535,
    height: 475,
    transform: "rotate(90 861 0)",
    fill: "url(#paint0_linear_180_3849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_3849",
    x1: 1128.5,
    y1: 0,
    x2: 1128.5,
    y2: 475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_3849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 860.475,
    height: 535,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTicket);
export default __webpack_public_path__ + "static/media/createTicket.6abcfb938eb0b2f68bbe099361c25602.svg";
export { ForwardRef as ReactComponent };